var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreVertLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 33.4751V25.0751H12.2V33.4751C12.2 34.8676 13.3075 35.9751 14.7 35.9751H33.5C34.8925 35.9751 36 34.8676 36 33.4751V25.0751H38.2V33.4751C38.2 36.0826 36.1075 38.1751 33.5 38.1751H14.7C12.0925 38.1751 10 36.0826 10 33.4751Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0067 27L23.0067 10L25.2067 10L25.2067 27H23.0067Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7272 28.034C24.8369 29.0876 23.2918 28.9407 22.4289 28.0778C22.4226 28.0715 22.4163 28.0651 22.4102 28.0586L16.4102 21.7586L18.0033 20.2414L23.9901 26.5276C24.0231 26.5583 24.057 26.5705 24.0804 26.5739C24.0921 26.5606 24.1041 26.5476 24.1164 26.5348L30.2164 20.2348L31.797 21.7652L25.7272 28.034Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreVertLight);
export default __webpack_public_path__ + "static/media/icon_more_vert_light.2fb0dd58.svg";
export { ForwardRef as ReactComponent };